import React from "react";
import {
  Box,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  useTheme,
} from "@mui/material";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import {
  SettingsOutlined,
  ChevronLeft,
  ChevronRightOutlined,
  HomeOutlined,
  ShoppingCartOutlined,
  ReceiptLongOutlined,
  PointOfSaleOutlined,
  CalendarMonthOutlined,
  AdminPanelSettingsOutlined,
  Person2Outlined,
  CreditCardOffRounded,
} from "@mui/icons-material";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import FlexBetween from "./FlexBetween";
import logoImage from "assets/ILLUSTRATION LOGO BISMOS .png";

const navItems = [
  {
    text: "Acceuil",
    icon: <HomeOutlined />,
  },
  {
    text: "Modules",
    icon: null,
  },
  {
    text: "Achats",
    icon: <ShoppingCartOutlined />,
  },

  {
    text: "Ventes",
    icon: <ReceiptLongOutlined />,
  },
  // {
  //   text: "Commandes",
  //   icon: <ShoppingCartOutlined />,
  // },
  {
    text: "Stocks",
    icon: <ReceiptLongOutlined />,
  },
  {
    text: "vente-prestation",
    icon: <ShoppingCartOutlined />,
  },
  {
    text: "clients",
    icon: <Person2Outlined />,
  }, 
  {
    text: "credit",
    icon: <CreditCardOffRounded/>,
  },
  {
    text: "Depenses",
    icon: <ReceiptLongOutlined />,
  },

  // {
  //   text: "Employés",
  //   icon: <Groups2Outlined />,
  // },
  // {
  //   text: "Crédits",
  //   icon: <CreditCardSharp />,
  // },
  // {
  //   text: "Devis",
  //   icon: <ReceiptLongOutlined />,
  // },

  {
    text: "Les statistiques",
    icon: null,
  },

  // {
  //   text: "Journalier",
  //   icon: <TodayOutlined />,
  // },
  {
    text: "Dépots-banque",
    icon: <ReceiptLongOutlined />,
  },
  {
    text: "Mensuel",
    icon: <CalendarMonthOutlined />,
  },
  // {
  //   text: "Graphe",
  //   icon: <PieChartOutlined />,
  // },
  {
    text: "Management",
    icon: null,
  },
  {
    text: "Admin",
    icon: <AdminPanelSettingsOutlined />,
  },
  {
    text: "faq",
    icon: <HelpOutlineOutlinedIcon />,
  },
  {
    text: "Imprimerie",
    icon: <PointOfSaleOutlined />,
  },
];

const Sidebar = ({
  user,
  drawerWidth,
  isSidebarOpen,
  setIsSidebarOpen,
  isNonMobile,
}) => {
  const { pathname } = useLocation();
  const [active, setActive] = useState("");
  const navigate = useNavigate();
  const theme = useTheme();

  useEffect(() => {
    setActive(pathname.substring(1));
  }, [pathname]);

  return (
    <Box component="nav">
      {isSidebarOpen && (
        <Drawer
          open={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
          variant="persistent"
          anchor="left"
          sx={{
            width: drawerWidth,
            "& .MuiDrawer-paper": {
              color: theme.palette.secondary[200],
              backgroundColor: theme.palette.background.alt,
              boxSixing: "border-box",
              borderWidth: isNonMobile ? 0 : "2px",
              width: drawerWidth,
            },
          }}
        >
          <Box width="100%">
            <Box m="1.5rem 2rem 2rem 3rem">
              <Box
                component="img"
                alt="logo bismos"
                src={logoImage}
                height="130px"
                width="130px"
                sx={{ objectFit: "cover" }}
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                  marginLeft: "7px",
                }}
              />
              <FlexBetween color={theme.palette.secondary.main}>
                <Box display="flex" alignItems="center" gap="0.5rem">
                  <Typography variant="h6" fontWeight="bold" color="white">
                    BISMOS IMPRIMERIE
                  </Typography>
                </Box>
                {!isNonMobile && (
                  <IconButton onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
                    <ChevronLeft />
                  </IconButton>
                )}
              </FlexBetween>
            </Box>
            <List>
              {navItems.map(({ text, icon }) => {
                if (!icon) {
                  return (
                    <Typography key={text} sx={{ m: "2.25rem 0 1rem 3rem" }}>
                      {text}
                    </Typography>
                  );
                }

                const lcText = text.toLowerCase();

                return (
                  <ListItem key={text} disablePadding>
                    <ListItemButton
                      onClick={() => {
                        navigate(`/${lcText}`);
                        setActive(lcText);
                      }}
                      sx={{
                        backgroundColor:
                          active === lcText
                            ? theme.palette.secondary[300]
                            : "transparent",
                        color:
                          active === lcText
                            ? theme.palette.primary[600]
                            : theme.palette.secondary[100],
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          ml: "2rem",
                          color:
                            active === lcText
                              ? theme.palette.primary[600]
                              : theme.palette.secondary[200],
                        }}
                      >
                        {icon}
                      </ListItemIcon>
                      <ListItemText primary={text} />
                      {active === lcText && (
                        <ChevronRightOutlined sx={{ ml: "auto" }} />
                      )}
                    </ListItemButton>
                  </ListItem>
                );
              })}
            </List>
          </Box>

          <Box position="relative" bottom="2rem">
            <br />
            <br />
            <Divider />
            <FlexBetween textTransform="none" gap="1rem" m="1.5rem 2rem 0 3rem">
              <Box
                component="img"
                alt="profile"
                src={`${user?.profilepic?.url}`}
                height="40px"
                width="40px"
                borderRadius="50%"
                sx={{ objectFit: "cover" }}
              />
              <Box textAlign="left">
                <Typography
                  fontWeight="bold"
                  fontSize="0.9rem"
                  sx={{ color: theme.palette.secondary[100] }}
                >
                  {user?.name}
                </Typography>
                <Typography
                  fontSize="0.8rem"
                  sx={{ color: theme.palette.secondary[200] }}
                >
                  {user.occupation}
                </Typography>
              </Box>
              <Link to="/settings">
                <SettingsOutlined
                  sx={{
                    color: theme.palette.secondary[300],
                    fontSize: "25px ",
                  }}
                />
              </Link>
            </FlexBetween>
          </Box>
        </Drawer>
      )}
    </Box>
  );
};

export default Sidebar;
